import { useTranslation } from "react-i18next"

interface SuccessPlaceholderProps {
  "aria-label"?: string
}

const SuccessPlaceholder = (props: SuccessPlaceholderProps) => {
  const { t } = useTranslation()

  return (
    <div
      className="container mx-auto px-4 py-8 animate-pulse"
      role="status"
      aria-live="polite"
      aria-label={t("general.loading", "Loading content")}
    >
      <div className="flex flex-col md:flex-row gap-8">
        <div className="flex-1">
          <div className="bg-theme_background rounded-lg border border-theme_text_light">
            <div className="p-6">
              <div className="h-8 w-64 bg-gray-300 animate-pulse rounded mb-4" />
              <div className="h-4 w-96 bg-gray-300 animate-pulse rounded mb-8" />

              <div className="md:hidden mb-8">
                <div className="h-6 w-48 bg-gray-300 animate-pulse rounded mb-4" />
                <div className="space-y-2">
                  {[1, 2].map((index) => (
                    <div key={index} className="flex justify-between mb-2">
                      <div className="h-4 w-32 bg-gray-300 animate-pulse rounded" />
                      <div className="h-4 w-16 bg-gray-300 animate-pulse rounded" />
                    </div>
                  ))}
                  <div className="flex justify-between pt-2 border-t border-theme_text_light">
                    <div className="h-4 w-20 bg-gray-300 animate-pulse rounded" />
                    <div className="h-4 w-24 bg-gray-300 animate-pulse rounded" />
                  </div>
                </div>
              </div>

              <div className="h-6 w-48 bg-gray-300 animate-pulse rounded mb-4" />
              <div className="h-4 w-96 bg-gray-300 animate-pulse rounded mb-4" />
              <div className="h-10 w-32 bg-gray-300 animate-pulse rounded mb-8" />

              <div className="h-6 w-48 bg-gray-300 animate-pulse rounded mb-4" />
              <div className="h-10 w-48 bg-gray-300 animate-pulse rounded" />
            </div>
          </div>
        </div>

        <div className="hidden md:block w-80">
          <div className="rounded-lg border border-theme_text_light p-6 sticky top-8">
            <div className="h-6 w-32 bg-gray-300 animate-pulse rounded mb-4" />
            <div className="space-y-2">
              {[1, 2].map((index) => (
                <div key={index} className="flex justify-between mb-2">
                  <div className="h-4 w-32 bg-gray-300 animate-pulse rounded" />
                  <div className="h-4 w-16 bg-gray-300 animate-pulse rounded" />
                </div>
              ))}
              <div className="flex justify-between pt-2 border-t border-theme_text_light">
                <div className="h-4 w-20 bg-gray-300 animate-pulse rounded" />
                <div className="h-4 w-24 bg-gray-300 animate-pulse rounded" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <span className="sr-only">{t("general.loading", "Loading content")}</span>
    </div>
  )
}

export { SuccessPlaceholder }
